import React from 'react'
import { Grid } from '../../BuildingCharacteristics.styles'
import type { ConstructionTimelineTabProps } from './ConstructionTimelineTab.types'
import { useBuildingAge, useConstructionDates } from './hooks'
import { getAgeCategory, getRenovationStatus } from './utils'
import {
  TimelineChart,
  AgeAnalysisCard,
  RenovationHistoryCard,
  NeighborhoodComparisonCard,
} from './components'

export const ConstructionTimelineTab: React.FC<
  ConstructionTimelineTabProps
> = ({ building, t }) => {
  const currentYear = new Date().getFullYear()

  const ageData = useBuildingAge(building)
  const { constructionDates, dwellingYears } = useConstructionDates(building)

  const buildingYear = ageData.year || 0
  const buildingAge = ageData.age
  const isAgeEstimate = ageData.isEstimate

  const renovationYear = building.renovation_year || 0
  const yearsSinceRenovation =
    renovationYear > 0 ? currentYear - renovationYear : 0

  const ageCategory = getAgeCategory(buildingAge, t)
  const renovationStatus = getRenovationStatus(yearsSinceRenovation, t)

  return (
    <>
      {/* Timeline Visualization */}
      <TimelineChart
        buildingYear={buildingYear}
        renovationYear={renovationYear}
        constructionDates={constructionDates}
        dwellingYears={dwellingYears}
        isAgeEstimate={isAgeEstimate}
        currentYear={currentYear}
        t={t}
      />

      <div style={{ marginBottom: 24 }} />

      {/* Age Analysis */}
      <Grid $columns={2}>
        <AgeAnalysisCard
          buildingYear={buildingYear}
          buildingAge={buildingAge}
          isAgeEstimate={isAgeEstimate}
          buildingPeriod={building.building_period}
          ageCategory={ageCategory}
          t={t}
        />

        <RenovationHistoryCard
          renovationYear={renovationYear}
          yearsSinceRenovation={yearsSinceRenovation}
          renovationPeriod={building.renovation_period}
          renovationStatus={renovationStatus}
          t={t}
        />
      </Grid>

      {/* Neighborhood Comparison */}
      {building.neighbors_building_year_mean && (
        <NeighborhoodComparisonCard
          buildingYear={buildingYear}
          buildingAge={buildingAge}
          isAgeEstimate={isAgeEstimate}
          neighborsMeanYear={building.neighbors_building_year_mean}
          currentYear={currentYear}
          t={t}
        />
      )}
    </>
  )
}
